export default {
  ApiCommon: require('./api-common').default,
  ApiOss: require('./api-oss').default,
  ApiUser: require('./api-user').default,
  ApiRole: require('./api-role').default,
  ApiMenu: require('./api-menu').default,
  ApiBatch: require('./api-batch').default,
  ApiSpecialty: require('./api-specialty').default,
  ApiFeeAudit: require('./api-fee-audit').default,
  ApiTimeAudit: require('./api-time-audit').default,
  ApiExamImport: require('./api-exam-import').default,
  ApiExamOnline: require('./api-exam-online').default,
  ApiOrderOnline: require('./api-order-online').default,
  ApiTrade: require('./api-trade').default,
  ApiOrder: require('./api-order').default,
  ApiSettle: require('./api-settle').default,
  ApiMember: require('./api-member').default,
  ApiBatchRecord: require('./api-batch-recording').default,
  ApiFinanceProxy: require('./api-finance').default,
  ApiMusicbasisOss: require('./api-musicbasis-oss').default
}
